import React from 'react';
import { AccountCircleIcon, EnvelopeIcon, NotificationsIcon, PeopleIcon, SettingsHollowIcon, WarningIcon, } from '@digitools/honest-ui/icons';
import { HeaderText } from './HeaderText';
import ProveText from '../prove/ProveText';
// Mirrors the account dropdown in src/components/header/Header.tsx lines 169-289.
// Kept as a pure function so the gating logic can be unit-tested and re-used
// by any future header variants without touching the JSX.
const buildAccountMenuItems = ({ user, isCommPrefEnabled, updatedEmployerEmailNotificationsEnabled, lfgHomeUrl, t, trackPageEvent, }) => {
    const items = [];
    if (user.isLfgUser && !user.isIdentityVerified) {
        items.push({
            as: 'link',
            linkType: 'local',
            title: t(ProveText.verifyHeadingAlt),
            icon: React.createElement(WarningIcon),
            url: '/profile/accountAccess',
            onClick: () => trackPageEvent(ProveText.verifyHeadingAlt.english, 'account access'),
        });
    }
    const lfgBranchEligible = user.isLfgUser &&
        (user.auth0Roles?.includes('MLPEmployee') ? user.isIdentityVerified : true);
    if (lfgBranchEligible) {
        const isPaOrMlp = user.auth0Roles?.includes('PA') || user.auth0Roles?.includes('MLPEmployee');
        if (isPaOrMlp) {
            items.push({
                as: 'link',
                linkType: 'external',
                title: t(HeaderText.profile),
                icon: React.createElement(AccountCircleIcon),
                url: `${lfgHomeUrl}/secure/roleRouter?pageId=profileinfo`,
                onClick: () => trackPageEvent('Profile information', 'home page'),
            });
            items.push({
                as: 'link',
                linkType: 'external',
                title: t(HeaderText.settings),
                icon: React.createElement(SettingsHollowIcon),
                url: `${lfgHomeUrl}/secure/roleRouter?pageId=securitysettings`,
                onClick: () => trackPageEvent('Security settings', 'home page'),
            });
        }
        else {
            items.push({
                as: 'link',
                linkType: 'external',
                title: t(HeaderText.profileAndPermissions),
                icon: React.createElement(AccountCircleIcon),
                url: `${lfgHomeUrl}/secure/roleRouter?pageId=profileinfo`,
                onClick: () => trackPageEvent('Profile and permissions', 'home page'),
            });
        }
    }
    else {
        items.push({
            as: 'link',
            linkType: 'local',
            title: t(HeaderText.profile),
            icon: React.createElement(AccountCircleIcon),
            url: '/profile/userInfo',
            onClick: () => trackPageEvent('Profile information', 'home page'),
        });
        items.push({
            as: 'link',
            linkType: 'local',
            title: t(HeaderText.settings),
            icon: React.createElement(SettingsHollowIcon),
            url: '/profile/password',
            onClick: () => trackPageEvent('Security settings', 'home page'),
        });
    }
    if (isCommPrefEnabled) {
        items.push({
            as: 'link',
            linkType: 'local',
            title: t(HeaderText.commPrefs),
            icon: React.createElement(NotificationsIcon),
            url: '/profile/alertsNotifications',
            onClick: () => trackPageEvent('Alerts and notifications', 'home page'),
        });
    }
    if (!updatedEmployerEmailNotificationsEnabled &&
        user.roles &&
        (user.roles.includes('employer') || user.roles.includes('internal'))) {
        items.push({
            as: 'link',
            linkType: 'local',
            title: t(HeaderText.emailNotifications),
            icon: React.createElement(EnvelopeIcon),
            url: '/admin/emailNotification',
            onClick: () => trackPageEvent('Email Notifications', 'home page'),
        });
    }
    if (user.roles &&
        (user.roles.includes('employeradmin') || user.roles.includes('internal')) &&
        user.customerInContext) {
        items.push({
            as: 'link',
            linkType: 'local',
            title: t(HeaderText.userAccess),
            icon: React.createElement(PeopleIcon),
            url: '/admin/permissions',
            onClick: () => trackPageEvent('User Access', 'home page'),
        });
    }
    return items;
};
export default buildAccountMenuItems;
